import AccordionTabs from './shared/responsiveAccordionTabs';

export default {
  init(store, domEl) {
    return new AccordionTabs({ container: domEl });
  },
};
